export const DEFAULT_NUMBER_OF_RESULTS_PER_PAGE = 24
